<div [ngStyle]="{ color: text.length > maxLength ? 'red' : '' }" class="pull-right">
  {{ text.length }} / {{ maxLength }}
</div>
